"use client";

import { useCallback, useState, type ReactNode } from "react";

export interface PillarFaqEntry {
  q: string;
  a: ReactNode;
}

/**
 * FAQ accordion. Questions and answers are server-rendered into the initial
 * HTML; this island only tracks which item is expanded.
 */
export function PillarFaqList({ items }: { items: PillarFaqEntry[] }) {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const toggleFaq = useCallback((idx: number) => {
    setOpenFaq((prev) => (prev === idx ? null : idx));
  }, []);

  return (
    <div className="faq-list">
      {items.map((faq, idx) => (
        <div className={`faq-item ${openFaq === idx ? "open" : ""}`} key={idx}>
          <button className="faq-q" onClick={() => toggleFaq(idx)}>
            <span>{faq.q}</span>
            <span className="faq-chevron">▼</span>
          </button>
          <div className="faq-a">
            <div className="faq-a-inner">{faq.a}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
